"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onlyTypeArray = exports.enumKeys = exports.onlyUnique = exports.filterUndefined = exports.removeUndefined = void 0;
const removeUndefined = (obj, drop = true) => {
    if (typeof obj === "object" && obj !== null) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (obj[key] === undefined) {
                    if (drop) {
                        delete obj[key];
                    }
                    else {
                        obj[key] = null;
                    }
                }
                else if (typeof obj[key] === "object") {
                    obj[key] = (0, exports.removeUndefined)(obj[key]);
                }
            }
        }
    }
    return obj;
};
exports.removeUndefined = removeUndefined;
/**
 * Confirms that the input is of type T and not undefined.  This is useful
 * as an array filter to signal to the type system that the result only
 * contains objects of type T.  Example
 *
 *    const widgets: Widget[] = [...].filter(filterUndefined)
 */
const filterUndefined = (t) => {
    return t !== undefined;
};
exports.filterUndefined = filterUndefined;
const onlyUnique = (value, index, array) => {
    return array.indexOf(value) === index;
};
exports.onlyUnique = onlyUnique;
/**
 * Enumerate the keys from the given object (which can also be an "enum").
 * This is convinient for looping over the keys of an object and maintining the
 * correct typings.  Usage:
 *
 *    for (const key in enumKeys(obj)) {
 *      const value = obj[key]; // This is now properly typed
 *      // Do something with value
 *    }
 */
const enumKeys = (obj) => {
    return Object.keys(obj || {}).filter((k) => Number.isNaN(+k));
};
exports.enumKeys = enumKeys;
/**
 * Filters an input array `potentialValues` so that the returned array includes
 * only unique values from `allowedValues`.  This is useful when sanitizing
 * user-supplied values in an array that should conform to a const typed-array.
 * For example, consider the following:
 *
 *    const ArtistGroupRoles = ["artist", "admin", "manager"] as const;
 *    type ArtistGroupRole = (typeof ArtistGroupRoles)[number];
 *
 * and we want to sanitize a user-supplied array such that we're given an
 * array that we know only contains items from `ArtistGroupRoles`.  Usage:
 *
 *    onlyTypeArray(["foo", "artist", "bar", "artist"], ArtistGroupRoles);
 *
 * Returns: [ 'artist' ]
 *
 */
const onlyTypeArray = (potentialValues, allowedValues) => potentialValues
    .map((v) => (allowedValues.includes(v) ? v : undefined))
    .filter(exports.onlyUnique)
    .filter(exports.filterUndefined);
exports.onlyTypeArray = onlyTypeArray;
//# sourceMappingURL=utils.js.map